const themeData = [
   {
      index: 0,
      label: 'Tropical Punch',
      background: 'linear-gradient(to right, #2e86ab, #27ae60)',
      text: '#fff',
      set: ['#2e86ab', '#b8d423', '#27ae60', '#9b59b6'],

      appBackground: '#121212',
      appSidebarBackground: '#333',
      appBtnBackground: '#3cd5d5',
      appText1: '#fff',
      appText2: '#333',
   },
   {
      index: 1,
      label: 'Pastel Dreams',
      background: 'linear-gradient(to bottom, #f5b0cb, #c1e1c1)',
      text: '#000',
      set: ['#f5b0cb', '#ffd8be', '#c1e1c1', '#e2d8b9'],

      appBackground: '#f5b0cb',
      appSidebarBackground: '#c1e1c1',
      appBtnBackground: '#333',
      appText1: '#fff',
      appText2: '#333',
   },
   {
      index: 2,
      label: 'Ocean Breeze',
      background: 'linear-gradient(to right, #70c1b3, #f3ffbd)',
      text: '#000',
      set: ['#70c1b3', '#a7d2cb', '#f3ffbd', '#ff165d'],

      appBackground: '#70c1b3',
      appSidebarBackground: '#f3ffbd',
      appBtnBackground: '#fff',
      appText1: '#000',
      appText2: '#fff',
   },
   {
      index: 3,
      label: 'Midnight Garden',
      background: 'linear-gradient(to bottom, #232020, #29524a, #d3b1a9)',
      text: '#fff',
      set: ['#232020', '#29524a', '#d3b1a9', '#d9e1e2'],

      appBackground: '#333',
      appSidebarBackground: '#242625',
      appBtnBackground: '#294e46',
      appText1: '#ecada5',
      appText2: '#fff',
   },
   {
      index: 4,
      label: 'Desert Sunset',
      background: 'linear-gradient(to bottom, #ffb347 , #b2b2b2 )',
      text: '#fff',
      set: ['#ffb347', '#ff5c5c', '#b2b2b2', '#ffc870'],

      appBackground: '#555',
      appSidebarBackground: '#cdb28c',
      appBtnBackground: '#333',
      appText1: '#fff',
      appText2: '#c3b29a',
   },
   {
      index: 5,
      label: 'Summer Love',
      background: 'linear-gradient(to right, #ffefd5 , #f08080 )',
      text: '#000',
      set: ['#ffefd5', '#ffd8be', '#f08080', '#e6a8d7'],

      appBackground: 'rgba(254,196,202, 1)',
      appSidebarBackground: '#fff',
      appBtnBackground: '#f08080',
      appText1: '#333',
      appText2: 'rgba(254,196,202, 1)',
   },
   {
      index: 6,
      label: 'Earthy Tones',
      background: 'linear-gradient(to bottom, #c0c0c0  , #8c4646 )',
      text: '#fff',
      set: ['#e6ccb2', '#c0c0c0', '#8c4646', '#774f38'],

      appBackground: '#121212',
      appSidebarBackground: '#774f38',
      appBtnBackground: '#000',
      appText1: '#fff',
      appText2: '#333',
   },
   {
      index: 7,
      label: 'Fresh Citrus',
      background: 'linear-gradient(to bottom, #ffb347 , #bde4a9 )',
      text: '#000',
      set: ['#ffb347', '#c4d4af', 'yellow', 'yellow'],

      appBackground: '#000',
      appSidebarBackground: '#444',
      appBtnBackground: '#ffb347',
      appText1: '#bde4a9',
      appText2: '#333',
   },
   {
      index: 8,
      label: 'Retro Vibes',
      background: 'linear-gradient(to right, #e6b3cc , #8c7284 )',
      text: '#fff',
      set: ['#e6b3cc', '#b8b8d1', '#8c7284', '#4f4f4f'],

      appBackground: '#111',
      appSidebarBackground: '#8c7284',
      appBtnBackground: '#fff',
      appText1: '#e6b3cc',
      appText2: '#eee',
   },
   {
      index: 9,
      label: 'Autumn Leaves',
      background: 'linear-gradient(to right, #d7b899 , #8c4646 )',
      text: '#fff',
      set: ['#d7b899', '#b2b2b2', '#8c4646', '#ff5733'],

      appBackground: '#000',
      appSidebarBackground: '#8c4646',
      appBtnBackground: '#d7b899',
      appText1: '#fff',
      appText2: '#333',
   },
   {
      index: 10,
      label: 'Nordic Nights',
      background: 'linear-gradient(to right, #000, #4a4a4a )',
      text: '#fff',
      set: ['#000', '#f2f2f2', '#4a4a4a', '#64b6ac'],

      appBackground: '#000',
      appSidebarBackground: '#111',
      appBtnBackground: '#4a4a4a',
      appText1: '#eee',
      appText2: '#111',
   },
]

export default themeData
